import { render } from "./RegForm.vue?vue&type=template&id=448a4b04"
import script from "./RegForm.vue?vue&type=script&lang=js"
export * from "./RegForm.vue?vue&type=script&lang=js"
script.render = render

export default script